"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.edenReportingService = void 0;
var auth_suite_fetch_1 = require("../../../auth-suite-fetch");
var issueEdenReportingToken = function () {
    var requestPath = "edenReportingToken";
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        path: requestPath,
    });
};
exports.edenReportingService = {
    issueEdenReportingToken: issueEdenReportingToken,
};
